let experienceElements = [
  {
    id: 1,
    title: "Licht",
    location: "Berlin, Germany",
    description: "Licht trifft Kunst",
    buttonText: "Künstler",
    date: "Juni 2022",
    icon: "licht",
  },
  {
    id: 2,
    title: "Holz und Essen",
    location: "Düsseldorf, NRW - Germany",
    description: "Holz mal anders",
    buttonText: "Künstler",
    date: "August 2022",
    icon: "holz",
  },
  {
    id: 3,
    title: "Stein und Holz",
    location: "London, Vereinigte Königreich Großbritannien ",
    description: "Welcome Africa",
    buttonText: "Künstler",
    date: "November 2022",
    icon: "holz",
  },
  {
    id: 4,
    title: "Licht",
    location: "Berlin, Deutschland",
    description: "Überraschung",
    buttonText: "Künstler",
    date: "Dezember 2022",
    icon: "licht",
  },
  {
    id: 5,
    title: "Die Elemente",
    location: "Rom, Italien",
    description: "Vereinigung",
    buttonText: "Künstler",
    date: "März 2022",
    icon: "licht",
  },
];

export default experienceElements;
